import { useMemo } from 'react';
import { Configuration, RetailersApi } from '@/api';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const useGetRetailersByIdsQuery = (retailerIds: string[], supplierId?: string) => {
  const auth = useAuth();
  const queryClient = useQueryClient();
  const retailersApi = useMemo(() => new RetailersApi(new Configuration(auth)), [auth]);
  const ids = [...new Set(retailerIds)].sort();
  const queryKey = ['retailers', 'byIds', supplierId, ids];

  const query = useQuery({
    queryKey,
    queryFn: () =>
      retailersApi.findRetailers(undefined, 0, ids.length, undefined, {
        supplierId,
        retailerId: ids,
      }),
    enabled: ids.length > 0,
  });

  return {
    retailers: query.data?.items ?? [],
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error,
    invalidateQuery: () => queryClient.invalidateQueries({ queryKey }),
  };
};

export default useGetRetailersByIdsQuery;
